import { FormlyModule } from '@ngx-formly/core';
import { NgxUploaderModule } from 'ngx-uploader';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { SnCommonModule } from '@lib/common';
import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { FileUploadFormFieldComponent } from './components/form-field/file-upload-form-field.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatCardModule,
    // Others
    NgxUploaderModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'file-upload',
          component: FileUploadFormFieldComponent,
        },
      ],
    }),
    // Libs
    SnIconModule,
    SnButtonModule,
    SnCommonModule,
    MatButtonModule,
    TranslationModule,
  ],
  declarations: [FileUploadComponent, FilePreviewComponent, FileUploadFormFieldComponent],
  exports: [FileUploadComponent, FilePreviewComponent],
})
export class SnFormFileUploadModule {}
